import Bulk_certificates from "@/api/bulk_certificates/bulk_certificates";
import fileDownload from "js-file-download";
import router from "@/router";

const bulk_certificates = new Bulk_certificates();

const bulk_certificatesModule = {
  namespaced: true,
  state: {
    items: [],
    modulesLookups: [],
    coursesLookups: [],
    loadCourses:false,
    loadModules:false,
    item: null,
    lookups: [],
    total: 0,
    load: false,
    loadItem:false,
  },
  getters: {
    items(state) {
      return state.items;
    },
    loadCourses(state){
      return state.loadCourses
    },
    loadModules(state){
      return state.loadModules
    },
    modulesLookups(state){
      return state.modulesLookups;
    },
    coursesLookups(state){
      return state.coursesLookups;
    },
    item(state) {
      return state.item;
    },
    load(state) {
      return state.load;
    },
    loadItem(state) {
      return state.loadItem;
    },
    total(state) {
      return state.total;
    },
    lookups(state) {
      return state.lookups;
    },
  },
  mutations: {
    SET_ITEMS: (state, certificates) => {
      state.items = certificates;
    },
    SET_LOAD_COURSES: (state, loadCourses) => {
      state.loadCourses = loadCourses;
    },
    SET_LOAD_MODULES: (state, loadModules) => {
      state.loadModules = loadModules;
    },
    SET_MODULES_LOOKUPS: (state, Modules) => {
      state.modulesLookups = Modules;
    },
    SET_COURSES_LOOKUPS: (state, Courses) => {
      state.coursesLookups = Courses;
    },
    SET_TOTAL_COURSES: (state, total) => {
      state.total = total;
    },
    SET_ITEMS_LOAD: (state, load) => {
      state.load = load;
    },
    SET_LOAD_ITEM: (state, loadItem) => {
      state.loadItem = loadItem;
    },
    SET_ITEM: (state, school) => {
      state.item = school;
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups;
    },
  },
  actions: {
    list({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true);
        bulk_certificates.list(payload).then(response => {
          commit('SET_ITEMS', response);
          commit('SET_ITEMS_LOAD', false);
          resolve();
        });
      });
    },
    modulesLookups({ commit },payload) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MODULES', true);
        bulk_certificates.modulesLookups(payload).then(response => {
          commit('SET_MODULES_LOOKUPS', response.modules);
          commit('SET_LOAD_MODULES', false);
          resolve();
        });
      });
    },
    coursesLookups({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_COURSES', true);
        bulk_certificates.coursesLookups().then(response => {
          commit('SET_COURSES_LOOKUPS', response.courses);
          commit('SET_LOAD_COURSES', false);
          resolve();
        });
      });
    },
    store({ commit }, payload) {
      return new Promise((resolve, reject) => {
        bulk_certificates
          .store(payload.query)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        console.log('-------------------------payload',payload);
        
        bulk_certificates
          .update(payload.id,payload.query)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    get({ commit , dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_ITEM', true);
        bulk_certificates.get(id)
          .then(response => {
            commit('SET_ITEM', response);
            commit('SET_LOAD_ITEM', false);
            dispatch('schools/updateBreadVale', response.name, { root: true })
            resolve(response);
          })
          .catch(error => {
            reject(error);
            commit('SET_LOAD_ITEM', false);
          });
      });
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        bulk_certificates
          .update(payload.id,payload.query)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        bulk_certificates
          .remove(id)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    restore({ commit }, id) {
      return new Promise((resolve, reject) => {
        bulk_certificates
          .restore(id)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    hardRemove({ commit }, id) {
      return new Promise((resolve, reject) => {
        bulk_certificates
          .hardRemove(id)
          .then(response => {
            
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default bulk_certificatesModule;
